<template>
<div :class="['hw-part-load_wrap',{'hw-part-load_wrap_light':visible}]" v-show="visible || (load && !part)">
  <i class="icon el-icon-refresh tran"></i>
</div>
</template>

<script>
export default{
    props:{
        visible :{
            type : Boolean,
            default : false
        },
        part : {
            type : Boolean,
            default : false
        }
    },
    computed:{
        load(){
            return this.$store.state.isLoading;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/css/common";
.hw-part-load_wrap{
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  position: absolute;
  left: 0;
  top:0;
  z-index: 99;
  .icon{
    font-size: 40px;
    position: absolute;
    top:50%;
    left: 50%;
    margin-left: -20px;
    margin-top: -20px;
    color: white;
    font-weight: bolder;
    animation: tran 1s ease infinite;
  }
}
@keyframes tran {
  from {
    transform: rotateZ(0deg);
  }
  to{
    transform: rotateZ(180deg);
  }
}
.hw-part-load_wrap_light{
  background: rgba(0,0,0,0);
  .icon{
    color: $btn_f;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hw-part-load.vue